/**
 * Séquençage V2 — Types côté front pour les packs V2 (Réglementaire / Adéquation / BS).
 *
 * Aligné sur les enums + DTOs backend (`com.preconys.domains.pledge.dto.enumeration.*`,
 * `com.preconys.domains.pack.dto.PrPackDto`, `PrPackDocumentDto`). Les valeurs string doivent
 * rester strictement identiques (sérialisation JSON).
 */

export enum PackTypeEnum {
  REGLEMENTAIRE = 'REGLEMENTAIRE',
  ADEQUATION = 'ADEQUATION',
  BS = 'BS',
}

export enum PackSubTypeEnum {
  CIF = 'CIF',
  IAS = 'IAS',
  CIF_IAS = 'CIF_IAS',
}

export enum PackStatusEnum {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  WAITING_SEQUENCING = 'WAITING_SEQUENCING',
  WAITING_SIGNATURE = 'WAITING_SIGNATURE',
  SIGNED = 'SIGNED',
  CANCELLED = 'CANCELLED',
  INVALIDATED = 'INVALIDATED',
  FAILURE = 'FAILURE',
}

export enum PrPackDocumentVariantEnum {
  MAIN = 'MAIN',
  PROGRAMMED_PAYMENT = 'PROGRAMMED_PAYMENT',
  STRUCTURED_PRODUCT = 'STRUCTURED_PRODUCT',
}

/**
 * Valeurs de {@code GedDocumentEnum} backend (limité aux documents portés par les packs V2 +
 * quelques entrées du Pack BS). À étendre au besoin sans rien retirer (alignement strict backend).
 */
export enum GedDocumentEnum {
  // Pack Réglementaire
  DOCUMENT_ENTREE_EN_RELATION = 'DOCUMENT_ENTREE_EN_RELATION',
  LETTRE_DE_MISSION = 'LETTRE_DE_MISSION',
  FICHE_CONNAISSANCE_CLIENT = 'FICHE_CONNAISSANCE_CLIENT',
  MANDAT_IAS = 'MANDAT_IAS',
  // Pack Adéquation
  RCDA = 'RCDA',
  CONVENTION_RTO = 'CONVENTION_RTO',
  ANNEXE_LETTRE_DE_MISSION = 'ANNEXE_LETTRE_DE_MISSION',
  ANNEXE_PRESENTATION_SUPPORTS_ALLOCATION = 'ANNEXE_PRESENTATION_SUPPORTS_ALLOCATION',
  // Pack BS
  BULLETIN_DE_SOUSCRIPTION = 'BULLETIN_DE_SOUSCRIPTION',
  AVENANT = 'AVENANT',
  // Pack juridique fusionné legacy (réutilisé pack-level — cf. ADR-028)
  PACK_JURIDIC_CIF = 'PACK_JURIDIC_CIF',
  PACK_JURIDIC_IAS = 'PACK_JURIDIC_IAS',
}

export interface PrPackDocumentDto {
  id?: number;
  packId?: number;
  gedDocumentId?: number | null;
  documentType: GedDocumentEnum;
  optional?: boolean;
  included?: boolean;
  variant?: PrPackDocumentVariantEnum;
  /** Séquençage V2 — HTML éditable Froala pour les docs NEW. */
  /**
   * Séquençage V2 (parité legacy) — fragments HTML éditables, un par fragment
   * template (couverture, pages intermédiaires, corps/signature).
   */
  editableHtmlFragments?: string[] | null;
  signedAt?: string | null;
  signedOutsidePlatform?: boolean | null;
  reusedFromPackDocumentId?: number | null;
  signatureTransactionId?: string | null;
  /** Champs spécifiques au Pack BS (null pour Réglementaire / Adéquation). */
  title?: string | null;
  productId?: number | null;
  supportId?: number | null;
  pdfMappingId?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface PrPackDto {
  id?: number;
  pledgeId: number;
  type: PackTypeEnum;
  subType: PackSubTypeEnum;
  eSignatureTransactionId?: string | null;
  /**
   * Séquençage V2 — image de {@code PrPack.eSignature.signatureUrl} alimenté à l'envoi
   * Universign. Permet à la slide finale (cohabitation avec la branche legacy) d'afficher
   * un lien copy-to-clipboard pour le pack courant en {@code WAITING_SIGNATURE}.
   */
  signatureUrl?: string | null;
  investorProfileKey?: string | null;
  status: PackStatusEnum;
  sentAt?: string | null;
  signedAt?: string | null;
  sequencingReleaseAt?: string | null;
  sendDelayHours?: number | null;
  createdAt?: string;
  updatedAt?: string;
  documents: PrPackDocumentDto[];
}
